import { z } from "zod";

import type { InferModelType } from "@/common/helpers/models";
import { createModel } from "@/common/helpers/models";

export type Locale = InferModelType<typeof localeModel>;

const localeModel = createModel(z.enum(["pl"]));

export const Locale = {
  ...localeModel,
  all: localeModel.schema.options,
  default: "pl" as const satisfies Locale,
};
